module.exports = __webpack_public_path__ + "static/assets/5a931b14b2d580d278cc65be8822a77a.png";